import React from 'react'
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 0,
        margin: theme && theme.spacing ? theme.spacing(0.5) : '4px'
    },
    primary: {
        backgroundColor: theme && theme.palette && theme.palette.primary ? theme.palette.primary.light : 'inherit',
        '& .MuiButton-label': {
            color: theme && theme.palette && theme.palette.primary ? theme.palette.primary.main : 'inherit',
        }
    },
}))

export default function ActionButton(props) {

    const { color, children, onClick } = props;
    const classes = useStyles();

    return (
        <Button
            className={`${classes.root} ${classes[color]}`}
            onClick={onClick}>
            {children}
        </Button>
    )
}
